import { Dialog } from '@headlessui/react';
import { useFormik } from 'formik';
import React from 'react';

import { postUploadUsers } from '../api/POST_uploadUser';
import Alert from '../components/Alert';
import { FormCSV } from '../pages/tech-support/Home.type';
import Modal from './Modal';

const ModalFormCsv = (props: {
	cancelButtonRef: React.MutableRefObject<null>;
	showModal: boolean;
	closeModal: () => void;
	toggleModalConfirmation: () => void;
	closeModalBackground: () => void;
}) => {
	const fileInputRef = React.useRef(null);
	const toggleLoading = () => setFieldValue('isLoading', !values.isLoading);
	const toggleUploadFile = () =>
		setFieldValue('isUploadSuccess', !values.isUploadSuccess);

	const handleOnFileLoad = (file: File) => {
		setFieldValue('file', file);
		toggleUploadFile();
	};

	const handleRemoveFile = () => {
		fileInputRef.current = null;
		setFieldValue('file', null);
		setFieldValue('isAlertVisible', false);
		toggleUploadFile();
	};

	const { values, handleSubmit, setFieldValue, resetForm } = useFormik<FormCSV>(
		{
			initialValues: {
				file: null,
				isUploadSuccess: false,
				isLoading: false,
				isAlertVisible: false,
				errorMessage: '',
			},
			validateOnMount: true,
			onSubmit: async (formValues) => {
				const formData = new FormData();
				formData.append('file', formValues.file);

				await postUploadUsers(formData).then(
					({ status, messageDescription }) => {
						if (status === 'success') {
							toggleLoading();
							props.closeModal();
							resetForm();
							props.toggleModalConfirmation();
						} else {
							setFieldValue('isAlertVisible', true);
							setFieldValue('errorMessage', messageDescription);
							toggleLoading();
						}
					},
				);
			},
		},
	);

	const onSubmit = () => {
		toggleLoading();
		handleSubmit();
	};

	return (
		<Modal
			cancelButtonRef={props.cancelButtonRef}
			isShowModal={props.showModal}
			closeModalBackground={props.closeModalBackground}
		>
			<div className="mb-6">
				{values.isAlertVisible && (
					<Alert showAlert={values.isAlertVisible} text={values.errorMessage} />
				)}
				<Dialog.Title
					as="div"
					className="text-left text-extraLarge text-gray-gray700 font-interMedium mb-6"
				>
					Import CSV
				</Dialog.Title>
				<div className="mb-6">
					<div>
						{values.isUploadSuccess ? (
							<div
								className={
									values.isAlertVisible
										? 'w-full h-24 border-2 flex justify-between items-center border-dashed rounded-lg border-danger-default p-4'
										: 'w-full h-24 border-2 flex justify-between items-center border-dashed rounded-lg border-gray-gray400 p-4'
								}
							>
								<div className="flex">
									<img src="/images/tnc.svg" className="mr-2" />
									<div
										className={
											values.isAlertVisible
												? 'text-large text-danger-default font-interMedium'
												: 'text-large text-primary-green font-interMedium'
										}
									>
										{values.file.name}
									</div>
								</div>
								<div onClick={handleRemoveFile} className="cursor-pointer">
									<img src="/images/remove.svg" />
								</div>
							</div>
						) : (
							<div>
								<button
									className="w-full h-24 border-2 flex justify-center items-center border-dashed rounded-lg border-gray-gray400 cursor-pointer"
									onClick={() => fileInputRef?.current.click()}
								>
									<div className="flex justify-center items-center">
										<img src="/images/upload.svg" className="mr-2" />
										<div className="text-large text-gray-gray400 font-interRegular">
											Tambahkan File CSV
										</div>
									</div>
								</button>
								<input
									onChange={(event) => handleOnFileLoad(event.target.files[0])}
									multiple={false}
									ref={fileInputRef}
									type="file"
									hidden
								/>
							</div>
						)}
					</div>
				</div>
				<p className="text-large text-center text-gray-gray500 font-interRegular">
					Pastikan kamu menggunakan format file CSV yang disediakan oleh sistem.
					<a
						href={`${process.env.REACT_APP_BASE_URL}/download-temp-user`}
						className="text-primary-green font-interMedium"
					>
						Download disini
					</a>
				</p>
			</div>
			<div className="flex space-x-4">
				<button
					type="button"
					className="w-1/2 p-4 text-center border-2 border-primary-green bg-white rounded-lg text-primary-green font-interSemiBold focus:outline-none focus:ring-transparent"
					onClick={props.closeModal}
					ref={props.cancelButtonRef}
				>
					Batal
				</button>
				<button
					disabled={!values.isUploadSuccess || values.isLoading}
					type="button"
					className={
						!values.isUploadSuccess
							? 'w-1/2 p-4 flex justify-center items-center text-center rounded-lg bg-gray-gray300 focus:outline-none focus:ring-transparent focus:ring-primary-green cursor-default'
							: 'w-1/2 p-4 flex justify-center items-center text-center rounded-lg bg-primary-green focus:outline-none focus:ring-transparent focus:ring-primary-green'
					}
					onClick={onSubmit}
				>
					{values.isLoading ? (
						<div>
							<img src="/images/spinner.gif" className="w-6 h-6" />
						</div>
					) : (
						<div
							className={
								!values.isUploadSuccess
									? 'text-large text-gray-gray500 font-interSemiBold'
									: 'text-large text-white font-interSemiBold'
							}
						>
							Simpan
						</div>
					)}
				</button>
			</div>
		</Modal>
	);
};

export default ModalFormCsv;
